import { IState } from 'shared/store';

import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

//TODO:Удалить селектор в CD-190863

export const CALLBACK_BUTTON_TEXT_EXPERIMENT = 'newbuiding_new_callback_button_desktop';

export const selectCallbackButtonTextExperimentActive = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, CALLBACK_BUTTON_TEXT_EXPERIMENT, 'enabled');
};
